import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import useScrollAnimation from "../useScrollAnimation";
import { Loader2 } from "lucide-react";
import { generateClient } from "aws-amplify/api";
import { getSlumSoccerEvents } from "../graphql/queries";

const client = generateClient();

const formatDate = (isoString) => {
  const options = { month: "short", day: "2-digit", year: "numeric" };
  return new Date(isoString).toLocaleDateString("en-US", options);
};

export function EventDetails(props) {
  const { id } = useParams(); // Get project ID from URL
  const [event, setEvent] = useState(null);
  const [html, setHtml] = useState(null);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      let pendingData = await client.graphql({
        query: getSlumSoccerEvents,
        variables: { eventId: id },
      });

      const event = pendingData["data"]["getSlumSoccerEvents"];
      const content = JSON.parse(JSON.parse(event.mainContent));
      setEvent(event);
      setHtml(content.html);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching event:", error);
      setIsLoading(false);
    }
  };

  useScrollAnimation();

  const LoadingIndicator = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <Loader2 className="animate-spin text-white" size={64} />
    </div>
  );

  // If loading, show the circular progress indicator
  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <section className="blog-inner main-container pb-0" id="main-container">
      <div className="container mx-auto px-4 py-8 -mt-3">
        <div className="row">
          <div className="col-lg-12 mx-auto">
            <div
              className="blog-details bg-white shadow-lg rounded-lg p-6"
              id="blog-section"
            >
              <div className="entry-header flex items-center mb-6">
                <div className="w-2/3">
                  <img
                    src={event.imgUrl}
                    className="img-fluid rounded-lg shadow-md transform transition duration-300 hover:scale-105 w-full"
                    alt={event.title}
                    draggable="false"
                  />
                </div>

                <div className="w-3/4 text-left pl-6">
                  <h2 className="entry-title cursor-pointer text-3xl font-bold text-gray-800 hover:text-orange-600 transition duration-300">
                    {event.title}
                  </h2>
                  <div className="post-meta text-gray-600 mt-2">
                    <span className="post-author font-semibold text-orange-600">
                      <a href="#">By Admin</a>
                    </span>
                    <span className="mx-2">|</span>
                    <span className="post-meta-date">
                      {formatDate(event.date)}
                    </span>
                    <span className="mx-2">|</span>
                    <span className="post-cat font-semibold text-orange-600">
                      <a href="#">Lifestyle, Event</a>
                    </span>
                    {/* <p className="mb-4 mt-2">first para goes here</p> */}
                  </div>
                </div>
              </div>
              {/* main content */}
              {html && <div dangerouslySetInnerHTML={{ __html: html }}></div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
